import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import AlertPreview from './AlertPreview';
import AlertControls from './AlertControls';

const AlertGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.ALERT]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.ALERT, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.ALERT, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">Alert Generator</h2>
      <AlertControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const AlertPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.ALERT]);
  return <AlertPreview config={config} />;
};

export default AlertGenerator;

